import { useCallback } from "react";
import { SuppliersApi, useAPIAction } from "melco-shared-logic";

export interface PublishSupplierProductButtonInterface {
  id: string;
}

export const usePublishSupplierProduct = () => {
  const [PublishSupplierProduct] = useAPIAction(
    SuppliersApi,
    async (
      api,
      PublishSupplierProductData: PublishSupplierProductButtonInterface
    ) => {
      const data = await api.supplierProductPublish({
        id: PublishSupplierProductData.id,
      });

      return {
        successMessages: [],
        data,
      };
    },
    { skipErrorHandling: true, translationPrefix: "" }
  );

  return useCallback(
    async (PublishActionDetails: PublishSupplierProductButtonInterface) => {
      return await PublishSupplierProduct(PublishActionDetails);
    },
    [PublishSupplierProduct]
  );
};
